import * as Yup from 'yup';

export const CLIENT_CATEGORIES = [
    { value: 'WASTE', label: 'Odpady' },
    { value: 'PACKAGING', label: 'PPWR obaly' },
];

export const formValues = {
    isAbroad: false,
    companyName: '',
    address: {
        street: '',
        zip: '',
        city: '',
        country: 'Slovensko',
    },
    identificationNumber: '',
    vatId: '',
    vatRegNo: '',
    contact: '',
    email: '',
    categories: ['WASTE', 'PACKAGING']
}

export const validation = (isAbroad = false) =>
    Yup.object({
        isAbroad: Yup.boolean(),
        categories: Yup.array()
            .of(Yup.string().oneOf(['WASTE', 'PACKAGING']))
            .min(1, 'Vyberte aspoň jednu kategóriu.'),
        companyName: Yup.string()
            .required('Názov spoločnosti je povinný.')
            .min(1, 'Minimálny počet znakov je 1.')
            .max(100, 'Maximálny počet znakov je 100.'),
        address: Yup.object({
            street: Yup.string()
                .required('Ulica je povinná.')
                .min(1, 'Minimálny počet znakov je 1.')
                .max(150, 'Maximálny počet znakov je 150.'),
            zip: isAbroad
                ? Yup.string()
                    .required('PSČ je povinné.')
                    .min(3, 'Minimálny počet znakov je 3.')
                    .max(20, 'Maximálny počet znakov je 20.')
                : Yup.string()
                    .required('PSČ je povinné.')
                    .matches(/^\d*$/, 'PSČ nie je vo formáte slovenského PSČ.')
                    .min(5, 'Minimálny počet znakov je 5.')
                    .max(5, 'Maximálny počet znakov je 5.'),
            city: Yup.string()
                .required('Mesto je povinné.')
                .min(2, 'Minimálny počet znakov je 2.')
                .max(50, 'Maximálny počet znakov je 50.'),
            country: Yup.string()
                .required('Krajina je povinná.'),
        }),
        identificationNumber: isAbroad
            ? Yup.string()
                .required('Registračné číslo je povinné.')
                .max(20, 'Maximálny počet znakov je 20.')
            : Yup.string()
                .required('IČO je povinné.')
                .max(8, 'Maximálny počet znakov je 8.'),
        vatId: Yup.string()
            .max(30, 'Maximálny počet znakov je 30.'),
        vatRegNo: Yup.string()
            .max(30, 'Maximálny počet znakov je 30.'),
        contact: isAbroad
            ? Yup.string()
                .matches(/^\+[0-9]{6,15}$/, 'Zadajte číslo vo formáte +XXXXXXXXXXX.')
                .max(16, 'Maximálny počet znakov je 16.')
            : Yup.string()
                .matches(/^\+421[0-9]{9}$/, 'Telefónne číslo nie je vo formáte slovenského čísla.')
                .min(13, 'Minimálny počet znakov je 13.')
                .max(13, 'Maximálny počet znakov je 13.'),
        email: Yup.string()
            .email('Nesprávny formát e-mailu.')
            .min(5, 'Minimálny počet znakov je 5.')
            .max(40, 'Maximálny počet znakov je 40.'),
    })
